import { getStorage, setStorage } from './storage'

const OLD_KEYS = ['@lang', 'apiEndpoints', 'selectedApiEndpoint', 'tableState']
const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0'

/**
 * Initialize storage and clear old keys if app version changed
 * Call this once on app startup (e.g., in main.tsx or Providers.tsx)
 */
export function initStorage(): void {
	const meta = getStorage('app-meta')

	if (meta?.version !== APP_VERSION) {
		// Clear old legacy keys
		OLD_KEYS.forEach((key) => localStorage.removeItem(key))

		// Update version
		setStorage('app-meta', { version: APP_VERSION })

		console.log(`[Storage] Cleared old keys, updated to version ${APP_VERSION}`)
	}
}
